export default __webpack_public_path__ + "static/media/levelTest-Illustration06.3a8a718a.jpg";